<div class="anc-dialog">
    <div class="anc-dialog__header">
        <span class="anc-dialog__leading">
            <ng-content select="[dialogHeaderLeading]"></ng-content>
        </span>
        <div class="anc-dialog__titles">
            <div class="anc-dialog__title" *ngIf="title()" translate>
                {{ title() }}
            </div>
            <div
                class="anc-dialog__subtitle"
                *ngIf="subtitle()"
                translate
            >
                {{ subtitle() }}
            </div>
        </div>
        <button
            *ngIf="showClose()"
            type="button"
            class="anc-dialog__close"
            aria-label="Close"
            (click)="dismiss.emit()"
        >
            <span aria-hidden="true" class="icon icon-close"></span>
        </button>
    </div>

    <div class="anc-dialog__body">
        <ng-content></ng-content>
    </div>

    <div class="anc-dialog__footer">
        <ng-content select="[dialogFooter]"></ng-content>
    </div>
</div>
